import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  finalizeProductsListTitle: {
    defaultMessage: '{stepNumber}. Finalize your products list',
    id: 'MbrHXY',
    description: 'Title for step 1 of prepare products',
  },
  finalizeProductsListDescription: {
    defaultMessage:
      "Create a complete list of the SKUs and quantities you'll be shipping to the warehouse. You can manually enter this list or import it as a CSV in the next step.",
    id: 'WFoVVa',
    description: 'Description for step 1 of prepare products',
  },
  downloadCsvTemplate: {
    defaultMessage: 'Learn about CSV product format',
    id: '1Ecema',
    description: 'Link text for learning about CSV product format and requirements',
  },
  finalizeProductsListCheckbox: {
    defaultMessage: "I've created a complete and accurate product list with SKUs and quantities.",
    id: 'oqUZgh',
    description: 'Checkbox text for step 1 completion',
  },
  attachBarcodesTitle: {
    defaultMessage: '{stepNumber}. Attach barcodes to each item',
    id: 'O7KjTC',
    description: 'Title for step 2 of prepare products',
  },
  attachBarcodesDescription: {
    defaultMessage:
      'Every product must have a visible barcode so our team can scan and fulfill orders accurately. If an item is too small for a sticker, place it in a bag with the barcode on the bag.',
    id: 'NfYyK2',
    description: 'Description for step 2 of prepare products',
  },
  learnMoreBarcodeRequirements: {
    defaultMessage: 'Learn more about barcode requirements',
    id: '/aBM3t',
    description: 'Link text for barcode requirements',
  },
  attachBarcodesCheckbox: {
    defaultMessage: "I've labeled each item with a scannable barcode following ShipStation requirements.",
    id: 'nMIrF+',
    description: 'Checkbox text for step 2 completion',
  },
  preparePackingListTitle: {
    defaultMessage: '{stepNumber}. Prepare a packing list',
    id: '7HhKcp',
    description: 'Title for step 3 of prepare products',
  },
  preparePackingListDescription: {
    defaultMessage:
      "Include a detailed packing list for each pallet or box you're sending. This helps us efficiently count and stock your items once they arrive. We use the packing list to generate warehouse receiving labels and ensure everything matches your shipment.",
    id: 'zV8+1T',
    description: 'Description for step 3 of prepare products',
  },
  learnMorePackingListRequirements: {
    defaultMessage: 'Learn more about packing list requirements',
    id: 'KtvAGf',
    description: 'Link text for packing list requirements',
  },
  preparePackingListCheckbox: {
    defaultMessage: "I've prepared a packing list for each box or pallet in my shipment.",
    id: 'SwV3bM',
    description: 'Checkbox text for step 3 completion',
  },
});
